import { FolderIcon, Typography } from "@firecms/ui";

import { getBreadcrumbSegments } from "../../WebDownloadsManager.utils";
import { type ExplorerBreadcrumbProps } from "../../WebDownloadsManager.types";

const ExplorerBreadcrumb: React.FC<ExplorerBreadcrumbProps> = ({ currentPath, onNavigate }) => {
  const segments = getBreadcrumbSegments(currentPath);

  return (
    <nav
      aria-label="Ordnerpfad"
      className="inline-flex flex-wrap items-center gap-2 rounded-md bg-surface-accent-50 px-3 py-2 dark:bg-surface-900"
    >
      <FolderIcon size="smallest" className="shrink-0 text-primary" />
      <span className="inline-flex flex-wrap items-center gap-1">
        {segments.map((segment, index) => {
          const isLast = index === segments.length - 1;

          return (
            <span key={segment.path || "root"} className="inline-flex items-center gap-1">
              {index > 0 ? <span className="text-surface-400">/</span> : null}
              {isLast ? (
                <Typography className="font-medium">{segment.label}</Typography>
              ) : (
                <button
                  type="button"
                  className="cursor-pointer border-none bg-transparent p-0 text-sm font-medium text-primary hover:underline"
                  onClick={() => {
                    onNavigate(segment.path);
                  }}
                >
                  {segment.label}
                </button>
              )}
            </span>
          );
        })}
      </span>
    </nav>
  );
};

export default ExplorerBreadcrumb;
